import { render, staticRenderFns } from "./ListLabourerTerminatedPage.vue?vue&type=template&id=7cd08182&"
import script from "./ListLabourerTerminatedPage.vue?vue&type=script&lang=js&"
export * from "./ListLabourerTerminatedPage.vue?vue&type=script&lang=js&"
import style0 from "./ListLabourerTerminatedPage.vue?vue&type=style&index=0&id=7cd08182&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports